export default __webpack_public_path__ + "static/media/a018-6.876c2f94.svg";